
import { Form } from "antd-mobile";
import { useCallback, useEffect } from "react";
import { FIELD_TYPE_MAP } from "./data";
import { cn, createBEM } from "@/libs";
import {DynamicFormItemProps, DynamicFormProps} from './DynamicForm'
import './index.scss';

const b = createBEM("i-dynamicform");

export const DynamicForm = (props: DynamicFormProps) => {
  const {onRef, items, dictMap, data, disabled, ...rest} = props;
  const [form] = Form.useForm();

  useEffect(() => {
    if(typeof props.onRef === 'function'){
      props.onRef(form);
    }
  }, [form]);


  const renderFormItem = useCallback((item: DynamicFormItemProps) => {
    const Component = FIELD_TYPE_MAP[item.fieldType];
    const options = dictMap && dictMap[item.fieldName] || [];
    const label = typeof item.fieldLabel ==='function' ? item.fieldLabel({data: data|| {}}): item.fieldLabel
    return <div className={cn(b('item'))} key={item.fieldName}>
        <Form.Item name={item.fieldName} label={label} extra={item.extra} >
        <Component 
          {...(item.initialProps || {})} 
          placeholder={item.placeholder || '请填写'} 
          options={options} 
          readOnly={disabled || item.readOnly} 
          data={data}
        />
      </Form.Item>  
      
    </div>
  }, [data, disabled])
  return <Form 
    layout="horizontal" 
    {...rest} 
    form={form} 
    className={cn(b())}
  >
    { props.items.map(renderFormItem)}
  </Form>
}